
import React from 'react';
import { TIER_OPTIONS } from '@/constants/tierOptions';

interface TierSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const TierSelect: React.FC<TierSelectProps> = ({ value, onChange, className }) => {
  return (
    <select
      className={`border rounded-md p-1.5 text-sm ${className || ''}`}
      value={value || 'standard'}
      onChange={(e) => onChange(e.target.value)}
    >
      {TIER_OPTIONS.map((option) => (
        <option key={option.value} value={option.value || 'standard'}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default TierSelect;
